import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  labelCaption: {
    color: theme.appColors.secondaryType,
  },
}));

export function RadioLabelWithCaption({
  caption,
  label,
}: {
  label: string;
  caption?: string;
}): JSX.Element {
  const { classes } = useStyles();

  return (
    <Grid container sx={{ flexDirection: 'column' }}>
      <Typography variant="body1">{label}</Typography>
      {caption && (
        <Typography className={classes.labelCaption} variant="caption">
          {caption}
        </Typography>
      )}
    </Grid>
  );
}
